import './MenuItemTemplate.css'

import React from 'react'

import { MenuItem, MenuItemOptions } from 'primereact/menuitem'
import { Tooltip } from 'primereact/tooltip'

type Props = {
  item: MenuItem
  options: MenuItemOptions
  isNavMinimized: boolean
}

export const MenuItemTemplate: React.FC<Props> = ({
  item,
  options,
  isNavMinimized,
}) => {
  const { id, label, icon } = item
  const { onClick } = options

  return (
    <>
      <a
        onClick={e => onClick(e)}
        id={id}
        className="p-menuitem-link"
        role="menuitem"
        data-pc-section="action"
        data-pr-tooltip={label}
        data-pr-position="right"
      >
        <span className="p-menuitem-icon" data-pc-section="icon">
          {icon}
        </span>

        <span className="p-menuitem-text" data-pc-section="label">
          {label}
        </span>
      </a>

      {/* Tooltip is only visible when nav is minimized */}
      {isNavMinimized && <Tooltip target={`#${id}`} />}
    </>
  )
}
